import {isValidElement, ReactNode} from "react";

// Children that carry no renderable text and no subtree to walk. Functions (render
// props) must be skipped, not stringified — String(fn) would inject function source
// code into the searchable text.
const EMPTY_NODES = new Set([null, undefined, true, false]);

/**
 * Recursively flatten a ReactNode (strings, numbers, arrays, elements, fragments)
 * into its text leaves; icons and non-text elements contribute nothing. The trim
 * runs on the FINAL flattened string only: trimming per leaf would collapse the
 * spaces between leaves ("<b>A</b> B" → "AB").
 */
const flattenNodeText = (node: ReactNode): string => {
  if (EMPTY_NODES.has(node as any)) return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  // Join with "" — JSX spacing is author-provided via {" "} literals; a separator
  // here would double every gap and bloat the searchable string.
  if (Array.isArray(node)) return node.map(flattenNodeText).join("");
  if (isValidElement(node)) return flattenNodeText((node.props as {children?: ReactNode}).children);
  return "";
};

export const reactNodeToText = (node: ReactNode): string => flattenNodeText(node).trim();
